export default __webpack_public_path__ + "static/media/36I-114280_-20878_0.b99af451.jpg";